import ConditionalToolTip from "components/design/conditionalToolTip";
import { Switch } from "components/DesignSystem/Switch/Switch";
import { useGroupAiStatus } from "hooks/useGroupAiStatus";
import { useIsGroupV2Platform } from "hooks/useIsGroupV2Platform";
import { useToast } from "hooks/useToast";
import { useToggleGroupAiMutation } from "store/apis/groupAiToggle";
import { BackendError } from "types/utils/error";

type GroupAiToggleProps = {
  groupId: string;
};

export const GroupAiToggle = ({ groupId }: GroupAiToggleProps) => {
  const { alertToast } = useToast();
  const { isAiEnabled } = useGroupAiStatus(groupId);
  const [toggleGroupAi, { isLoading: isTogglingAi }] =
    useToggleGroupAiMutation();
  const isGroupV2Platform = useIsGroupV2Platform();

  const handleAiToggle = async () => {
    try {
      await toggleGroupAi({ groupId }).unwrap();
    } catch (err) {
      alertToast({
        message:
          (err as BackendError).data?.error?.message ?? "Something went wrong",
      });
    }
  };

  if (!isGroupV2Platform) {
    return null;
  }

  return (
    <ConditionalToolTip
      condition={
        isAiEnabled ? (
          <div className="t-text-start">
            Turn off to stop AI from replying across
            <br />
            this account
          </div>
        ) : (
          <div className="t-text-start">
            Turn on to let AI reply to queries across
            <br />
            this account
          </div>
        )
      }
      side="bottom"
      align="end"
    >
      <div className="t-flex t-flex-row-reverse t-gap-2 t-items-center">
        <Switch
          className="t-peer"
          size="small"
          name="group-ai-enable"
          id="group-ai-enable"
          checked={isAiEnabled}
          disabled={isTogglingAi}
          onCheckedChange={() => void handleAiToggle()}
        />
        <label
          htmlFor="group-ai-enable"
          className="t-select-none peer-data-[state=checked]:t-text-purple peer-data-[state=unchecked]:t-text-neutral t-text-body t-font-semibold"
        >
          AI
        </label>
      </div>
    </ConditionalToolTip>
  );
};
